import { createApplicationApi } from '@/modules/service-desk/shared/application-api';
import { runServiceDeskWorkflow } from '@/modules/service-desk/shared/application-workflows';
import { ByodApplication, ByodStatus } from '../types/byod.types';
import { ByodApplyValues } from '../schemas/byod-apply-form-schema';
import { BYOD_FIELDS } from '../graphql/byod.fields';

export const byodApi = createApplicationApi<ByodApplication>('ByodApplication', BYOD_FIELDS);

interface SubmitByodParams {
  /** Present when editing an existing application. */
  existing?: ByodApplication;
  values: ByodApplyValues;
}

/**
 * Legacy `CreateByodApplicationCommand`, now the BYOD_APPLICATION_SUBMIT workflow: create as Pending, or
 * the applicant's edit while Pending. It reads the department's name and keeps the saved bank details.
 */
export const submitByodApplication = ({ existing, values }: SubmitByodParams) =>
  runServiceDeskWorkflow('BYOD_APPLICATION_SUBMIT', {
    itemId: existing?.ItemId,
    firstName: values.firstName.trim(),
    lastName: values.lastName.trim(),
    employeeId: values.employeeId.trim(),
    email: values.email.trim(),
    designation: values.designation.trim(),
    mobileNumber: values.phoneNumber.trim(),
    bankAccount: values.bankAccount.trim(),
    departmentId: values.departmentId,
    deviceModel: values.deviceModel.trim(),
    computerProcessor: values.computerProcessor.trim(),
    motherboard: values.motherboard.trim(),
    ramCapacity: values.ramCapacity.trim(),
    monitorSpec: values.monitorSpec.trim(),
    storageSpec: values.storageSpec.trim(),
  });

interface ChangeByodStatusParams {
  itemId: string;
  status: ByodStatus;
}

/** Legacy `UpdateByodApplicationStatusCommand` (BYOD_APPLICATION_REVIEW workflow). */
export const changeByodStatus = ({ itemId, status }: ChangeByodStatusParams) =>
  runServiceDeskWorkflow('BYOD_APPLICATION_REVIEW', { itemId, status });
